import { render, staticRenderFns } from "./registrationDialog2.vue?vue&type=template&id=5c2feb3c&scoped=true&"
import script from "./registrationDialog2.vue?vue&type=script&lang=js&"
export * from "./registrationDialog2.vue?vue&type=script&lang=js&"
import style0 from "./registrationDialog2.vue?vue&type=style&index=0&id=5c2feb3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2feb3c",
  null
  
)

export default component.exports